/**
 * ======================================================================
 *  STATE
 * ======================================================================
 */

const state = {
    assetTypeId: null,
    insuranceTiers: [],
    groupedInsuranceTiers: [],
    comprehensiveTiers: [],
    cciBciTiers: [],
    warrantyTiers: [],
    gapTiers: [],
    insuranceConsentOptions: {},
    consentedComprehensiveTiers: [],
    nonConsentedComprehensiveTiers: [],
    floatingMaxRate: 0,
}

/**
 * ======================================================================
 *  GETTERS
 * ======================================================================
 */

const getters = {
    getInsuranceTiers: state => {
        return state.insuranceTiers
    },
    getGroupedInsuranceTiers: state => {
        return state.groupedInsuranceTiers
    },
    getComprehensiveTiers: state => {
        return state.comprehensiveTiers
    },
    getCciBciTiers: state => {
        return state.cciBciTiers
    },
    getWarrantyTiers: state => {
        return state.warrantyTiers
    },
    getGapTiers: state => {
        return state.gapTiers
    },
    getInsuranceConsentOptions: state => {
        return state.insuranceConsentOptions
    },
    getRemovedComprehensiveTiers: state => {
        return state.nonConsentedComprehensiveTiers
    },
    getFloatingMaxRate: state => {
        return state.floatingMaxRate
    }
}

/**
 * ======================================================================
 *  MUTATIONS
 * ======================================================================
 */

const mutations = {
    setInsuranceTiers(state, data) {

        state.insuranceTiers        = data
        state.comprehensiveTiers    = data.filter(payload => payload.title == 'Comprehensive')
        state.cciBciTiers           = data.filter(payload => payload.title == 'CCI/BCI')
        state.warrantyTiers         = data.filter(payload => payload.title == 'Warranty')
        state.gapTiers              = data.filter(payload => payload.title == 'GAP')

        let titles = Array.from(new Set(data.map((a) => a.title)))
        for (let title of titles) {
            let insuranceClass = data.filter((insurance) => insurance.title == title)
            // add default value
            insuranceClass.unshift({
                title: title,
                id: null,
                base_price: 0,
                premium: {
                    qld: 0,
                    sa: 0,
                    act: 0,
                    nsw: 0,
                    vic: 0,
                    wa: 0,
                    tas: 0,
                    nt: 0,
                },
                price: 0,
                insurance_id: null,
                tenants: [],
                name: "Please select tier",
                min_amount: 0,
                max_amount: 0,
                max_amount_localised: {},
                insurance: {},
                is_discretionary_product: 1,
            })

            state.groupedInsuranceTiers.push(insuranceClass)
        }

        if (!_.isEmpty(state.comprehensiveTiers) && _.size(state.comprehensiveTiers) > 0) {
            state.comprehensiveTiers.forEach((insurance) => {
                insurance.label = insurance.name
                insurance.value = insurance.id
                if (!_.isEmpty(insurance.insurance)) {
                    if (state.insuranceConsentOptions.consentRequired && !state.insuranceConsentOptions.hasConsented) {
                        if (!state.insuranceConsentOptions.insuranceOptions.insurers.includes(insurance.insurance.id)) {
                            if (!state.consentedComprehensiveTiers.some(comp => comp.value == insurance.insurance.id)) {
                                state.consentedComprehensiveTiers.push({
                                    value: insurance.insurance.id,
                                    label: insurance.insurance.name,
                                })
                            }
                        } else {
                            if (!state.nonConsentedComprehensiveTiers.some(comp => comp.value == insurance.insurance.id)) {
                                state.nonConsentedComprehensiveTiers.push({
                                    value: insurance.insurance.id,
                                    label: insurance.insurance.name,
                                })
                            }
                        }
                    } else {
                        if (!state.consentedComprehensiveTiers.some(comp => comp.value == insurance.insurance.id)) {
                            state.consentedComprehensiveTiers.push({
                                value: insurance.insurance.id,
                                label: insurance.insurance.name,
                            })
                        }
                    }
                }
            })
        }
    },
    setInsuranceConsentOptions(state, data) {
        state.insuranceConsentOptions = data
    },
    setAssetTypeId(state, data) {
        state.assetTypeId = data
    },
    setFloatingMaxRate(state, data) {
        state.floatingMaxRate = data
    },
}

/**
 * ======================================================================
 *  ACTIONS
 * ======================================================================
 */
const actions = {

    setInsuranceTiers({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {

            let assetTypeId = _.get(data, 'assetTypeId', _.get($store.getters.initAppData, 'asset_type_id', false))

            if (assetTypeId && state.assetTypeId != assetTypeId || assetTypeId && _.get(data, 'force', false)) {

                commit('setAssetTypeId', assetTypeId)

                axios.post(`${process.env.MIX_APP_URL}/api/get-insurance-tiers`, {
                    tenantId: parseInt(Ambition.getGlobal('tenant').tenantId),
                    assetTypeId: assetTypeId
                }, {
                    headers: { Authorization: "Bearer " + $store.getters.adminToken },
                }).then(
                    response => {
                        axios
                            .post(`/admin/comprehensive-insurance-options/${$store.getters.appId}/get-consent`)
                            .then((optionsResponse) => {
                                commit("setInsuranceConsentOptions", optionsResponse.data)
                                commit("setInsuranceTiers", response.data)
                            })
                            .catch((err) => {
                                console.error(err)
                            })
                        resolve(response)
                    },
                    error => {
                        reject(error)
                    }
                )
            } else {
                resolve(state.insuranceTiers)
            }
        })
    },
    setFloatingMaxRate({ dispatch, commit, state }, data) {
        commit("setFloatingMaxRate", data)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
